import businessManagerSettings from 'api/business-manager-settings/business-manager-settings';
import WixSDK from 'shared/utils/wix-sdk';


const instance = WixSDK.Utils.getInstance();


export const getBusinessManagerSettings = () =>
  businessManagerSettings
    .get('/settings', {
      params: {
        instance,
      },
    })
    .then(response => response.data)
    .catch(() => null);



// WEBPACK FOOTER //
// ./src/api/business-manager-settings/get/get.js